import {OptionValue} from "./form";
import {JsonTemplate} from "../generated-api";

export const TEMPLATE_TYPE_EMAIL = 'EMAIL';
export const TEMPLATE_TYPE_INVITE = 'INVITE';

export const templateTypeOptions: OptionValue[] = [
    {value: TEMPLATE_TYPE_EMAIL, label: 'E-mail'},
    {value: TEMPLATE_TYPE_INVITE, label: 'Text v pozvánce'},
];

/** Email template codes are NotificationType names, INVITE templates use their own codes. Listed in the order they happen in a season. */
export const templateCodeOptions: OptionValue[] = [
    {value: 'INVITE_ORG', label: 'INVITE_ORG', tooltip: 'Pozvánka organizátora'},
    {value: 'INVITE_ORG_RETURN', label: 'INVITE_ORG_RETURN', tooltip: 'Organizátor – vráceno k doplnění'},
    {value: 'INVITE_ORG_CONFIRM', label: 'INVITE_ORG_CONFIRM', tooltip: 'Organizátor – potvrzení registrace'},
    {value: 'INVITE_ORG_CANCEL', label: 'INVITE_ORG_CANCEL', tooltip: 'Organizátor – storno'},
    {value: 'SAFETY_ORG', label: 'SAFETY_ORG', tooltip: 'Proškolení BOZP a PO'},
    {value: 'SAFETY_ORG_CANCEL', label: 'SAFETY_ORG_CANCEL', tooltip: 'BOZP – storno'},
    {value: 'INVITE_GUEST', label: 'INVITE_GUEST', tooltip: 'VIP pozvánka'},
    {value: 'INVITE_GUEST_RETURN', label: 'INVITE_GUEST_RETURN', tooltip: 'VIP – vráceno k doplnění'},
    {value: 'INVITE_GUEST_CONFIRM', label: 'INVITE_GUEST_CONFIRM', tooltip: 'VIP – potvrzení registrace'},
    {value: 'INVITE_GUEST_CANCEL', label: 'INVITE_GUEST_CANCEL', tooltip: 'VIP – storno'},
    {value: 'INVITE_SUPP', label: 'INVITE_SUPP', tooltip: 'Dodavatel'},
    {value: 'INVITE_SUPP_RETURN', label: 'INVITE_SUPP_RETURN', tooltip: 'Dodavatel – vráceno k doplnění'},
    {value: 'INVITE_SUPP_CONFIRM', label: 'INVITE_SUPP_CONFIRM', tooltip: 'Dodavatel – potvrzení'},
    {value: 'INVITE_SUPP_CANCEL', label: 'INVITE_SUPP_CANCEL', tooltip: 'Dodavatel – storno'},
    {value: 'UPDATE_ORG', label: 'UPDATE_ORG', tooltip: 'Výzva k doplnění údajů'},
    {value: 'UPDATE_ORG_RETURN', label: 'UPDATE_ORG_RETURN', tooltip: 'Doplnění údajů – vráceno'},
    {value: 'UPDATE_ORG_CONFIRM', label: 'UPDATE_ORG_CONFIRM', tooltip: 'Doplnění údajů – potvrzení'},
    {value: 'UPDATE_ORG_CANCEL', label: 'UPDATE_ORG_CANCEL', tooltip: 'Doplnění údajů – storno'},
    {value: 'TRAVEL_ORG', label: 'TRAVEL_ORG', tooltip: 'Cestovní náhrady'},
    {value: 'TRAVEL_ORG_RETURN', label: 'TRAVEL_ORG_RETURN', tooltip: 'Cestovní náhrady – vráceno'},
    {value: 'TRAVEL_ORG_CONFIRM', label: 'TRAVEL_ORG_CONFIRM', tooltip: 'Cestovní náhrady – potvrzení'},
    {value: 'TRAVEL_ORG_CANCEL', label: 'TRAVEL_ORG_CANCEL', tooltip: 'Cestovní náhrady – storno'},
    {value: 'COMP_ORG', label: 'COMP_ORG', tooltip: 'Výzva k potvrzení výplaty'},
    {value: 'COMP_ORG_RETURN', label: 'COMP_ORG_RETURN', tooltip: 'Výplata – vráceno'},
    {value: 'COMP_ORG_CONFIRM', label: 'COMP_ORG_CONFIRM', tooltip: 'Výplata – potvrzení'},
    {value: 'COMP_ORG_CANCEL', label: 'COMP_ORG_CANCEL', tooltip: 'Výplata – storno'},
    {value: 'COMP_ORG_INFO', label: 'COMP_ORG_INFO', tooltip: 'Text v pozvánce k výplatě'},
    {value: 'EVENT_GROUP_ORG', label: 'EVENT_GROUP_ORG', tooltip: 'Informace pro skupinu'},
    {value: 'USER_ACTIVATE', label: 'USER_ACTIVATE', tooltip: 'Aktivace uživatele'},
    {value: 'USER_RECOVER', label: 'USER_RECOVER', tooltip: 'Obnova hesla'},
];

export const templateCodeTitle = (templateCode?: string): string => {
    const option = templateCodeOptions.find((o) => o.value === templateCode);
    return option?.tooltip || templateCode || '';
};

/** Only the invites let the sender pick one of more variants of the text. */
export const isTemplateWithVariants = (templateCode?: string): boolean =>
    templateCode === 'INVITE_ORG' || templateCode === 'INVITE_GUEST';

export const compareTemplates = (a: JsonTemplate, b: JsonTemplate): number => {
    const ia = templateCodeOptions.findIndex((o) => o.value === a.templateCode);
    const ib = templateCodeOptions.findIndex((o) => o.value === b.templateCode);
    if (ia !== ib) {
        return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
    }
    if (!!a.isPrimary !== !!b.isPrimary) {
        return a.isPrimary ? -1 : 1;
    }
    return (a.templateData?.title || '').localeCompare(b.templateData?.title || '');
};
